import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';

const initialState = {
    list: {
        showEditPackage: false,
        isLoading: true,
        packages: [],
        error: "",
        currentPage: 1,
        pageCount: 0,
        search: '',
        currentPackage: '',
        currentRequiredDate: '',
        packageSelected: 'Packages List',
        column:'',
        order:'',
        materialId:'',
        confirmDeletePopup: false,
        fieldBomUrl: '',
        packageType: '',
        showIso:'',
        isoPipelines:[],
        selectedFacility: {value: null, label: ''},
        spoolSearch: '',
        selectedProject: {value: null, label: ''},
        showConfirmShipped: false,
        shippedPackageDetails: null,
        onHoldPackage: { id: '', type: '', onHold: false },
        showOnHoldModal: false,
    },
}

const listPackages = createNamespacer("PACKAGES_LIST")

export const listReducer = createReducer(initialState.list, {
    "SET_SHOW_EDIT_PACKAGE": (state, action) => {
        return {
            ...state,
            showEditPackage: action.payload.value,
            currentPackage: state.showEditPackage,
            currentRequiredDate: action.payload.date,
            materialId: action.payload.materialId,
            packageType: action.payload.type,
            requiredDateDisabled: action.payload.requiredDateDisabled
        }
    },
    "SET_PACKAGE_SELECTED": (state, action) => {
        return {
            ...state,
            packageSelected: action.payload.value
        }
    },
    "SET_TYPE": (state, action) => {
        return {
            ...state,
            packageType: action.payload.type
        }
    },
    "TOGGLE_DELETE_POPUP": (state, action) => {
        return {
            ...state,
            confirmDeletePopup: action.payload.value
        }
    },
    "SET_FIELD_BOM_URL": (state, action) => {
        return {
            ...state,
            fieldBomUrl: action.payload.value
        }
    },
    [listPackages("SET_SELECTED_PROJECT")]: (state, action) => {
        return {
            ...state,
            selectedProject: action.payload.value
        }
    },
    [listPackages("SHOW_ISO")]:(state, action) => {
        return {
            ...state,
            showIso: action.payload.value,
        }
    },
    [listPackages("SET_ISO_PIPELINES")]:(state, action) => {
        return {
            ...state,
            isoPipelines: action.payload.value,
        }
    },
    [listPackages("SET_SEARCH_PACKAGES")]:(state, action) => {
        return {
            ...state,
            search: action.payload.value,
        }
    },
    [listPackages("SET_COLUMN_AND_ORDER")]:(state, action) => {
        return {
            ...state,
            column: action.payload.column,
            order: action.payload.order
        }
    },

    [listPackages("SET_CLEAR_SEARCH")]:(state, action) => {
        return {
            ...state,
            search: initialState.search
        }
    },
    [listPackages("SET_PACKAGES")]:(state, action) => {
        return {
            ...state,
            packages: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [listPackages("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [listPackages("SET_PAGE")]:(state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [listPackages("SET_ERROR")]:(state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [listPackages("SET_SELECTED_FACILITY")]:(state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.facility,
        }
    },
    [listPackages("SET_SPOOL_SEARCH")]: (state, action) => {
        return {
            ...state,
            spoolSearch: action.payload.value
        }
    },
    [listPackages("SET_SHOW_SHIPPED")]: (state, action) => {
        return {
            ...state,
            showConfirmShipped: action.payload.value
        }
    },
    [listPackages("SET_SHIPPED_PACKAGE")]: (state, action) => {
        return {
            ...state,
            shippedPackageDetails: action.payload.value
        }
    },
    [listPackages("SET_ON_HOLD_PACKAGE")]: (state, action) => {
        return {
            ...state,
            onHoldPackage: action.payload.value
        }
    },
    [listPackages("SET_ON_HOLD_MODAL")]: (state, action) => {
        return {
            ...state,
            showOnHoldModal: action.payload.value
        }
    },
});
